import TimerIcon from "@mui/icons-material/Timer";
import _ from "lodash";
import {
    getCurrentUser,
    secondsToMinutesHour,
    showGreenTimer,
    showRedTimer,
    timeDifferenceInSeconds,
} from "../../../../../_helpers";
import moment from "moment";
import { LOCK_DURATION_IN_SECS } from "../../../../../_constants";
import MessageLockIcon from "@mui/icons-material/Lock";
import React, { Fragment } from "react";
import Tooltip from "@mui/material/Tooltip";

export default function ConversationDuration({ message }) {
    const user = getCurrentUser();
    const INCOMING = "incoming";
    const lockedAtTime = _.get(message, "lockedAtTime");
    let lockedMsgTimeDiff = timeDifferenceInSeconds(
        moment(lockedAtTime).format("YYYY-MM-DD HH:mm:ss"),
        moment().format("YYYY-MM-DD HH:mm:ss")
    );
    const lockedByCurrentUser = _.get(message, "lockedByUser") === _.get(user, "id");
    const dateCreated = _.get(message, "dateCreated");
    let newMsgTimeDiff = timeDifferenceInSeconds(
        moment(dateCreated).format("YYYY-MM-DD HH:mm:ss"),
        moment().format("YYYY-MM-DD HH:mm:ss")
    );
    let timeInMinsHour = secondsToMinutesHour(newMsgTimeDiff);
    const direction = _.get(message, "direction");
    const isAutoEscalated = _.get(message, "isAutoEscalated");
    const hasEmployeeSeen = _.get(message, "hasEmployeeSeen");
    const messageActioned = message.actioned ? message.actioned : message?.userMessageActions && message.userMessageActions.length > 0;
    const isProactive = _.get(message, "isProactive");
    const _handleType = _.get(message, "dataSourceHandle.type");
    const shouldDisplayTimer = direction && direction?.toLowerCase() === INCOMING && !isAutoEscalated && !hasEmployeeSeen && !messageActioned && dateCreated && !isProactive;

    if (lockedAtTime && lockedMsgTimeDiff < LOCK_DURATION_IN_SECS && !lockedByCurrentUser) {
        return (
            <MessageLockIcon className={`color-grey-mid`} fontSize={"small"} />
        );
    } else if (shouldDisplayTimer && showGreenTimer(_handleType, newMsgTimeDiff)) {
        return (
            <Tooltip title={timeInMinsHour} placement={"bottom"} enterDelay={100}>
                <TimerIcon className={`color-green`} fontSize={"small"} />
            </Tooltip>
        );
    } else if (shouldDisplayTimer && showRedTimer(_handleType, newMsgTimeDiff)) {
        return (
            <Tooltip title={timeInMinsHour} placement={"bottom"} enterDelay={100}>
                <TimerIcon className={`color-danger`} fontSize={"small"} />
            </Tooltip>
        );
    }else{
        return <Fragment/>
    }
}
